<section class="return-page">
  <section class="first-section">
    <div class="vaccine-title">
      {{constantsValue.expiredVaccinesTitle}}
    </div>
    <div>
      {{constantsValue.expiredVaccine}}
    </div>
    <div class="mb-3 mt-2">
      {{constantsValue.expiredVaccineReturn}}
    </div>
  </section>
  <section class="mb-3">
    <div class="question-style d-flex">
      <div class="mt-1 mr-3">1</div>
      <div>{{constantsValue.firstQuestion}}</div>
    </div>
    <p>
      {{constantsValue.firstAnswer}}
    </p><br />
    <div class="vaccine-product">
      {{constantsValue.vaccineProduct}}
    </div>
    <div class="search-component">
      <app-return-search (selectedProductEvent)="getSelectedProduct($event)"></app-return-search>
    </div>
    <div class="mt-4">
      <table class="order-list-table table" *ngIf="productList.length">
        <thead>
          <tr>
            <th colspan="4">Product</th>
            <th scope="col">NDC #</th>
            <th scope="col">Lot # (optional)</th>
            <th scope="col">Doses to return</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of productList">
            <td colspan="4" [innerHTML]="item.name"></td>
            <td>{{item.ndcNumber}}</td>
            <td><input id="lotNo" type="text" placeholder="Lot #"
                (keyup)="updateLotDoses($event.target.value,'lotno',item.id)"
                (keydown)="validateInput($event,'lotNoDose')" /></td>

            <td><input type="number" placeholder="0" min="1" max="99999"
                (keyup)="updateLotDoses($event.target.value,'doses',item.id)"
                (keydown)="validateInput($event,'lotNoDose')" /></td>
            <td><span class="del-icon" style="background: url(/icons/{{baseSiteId}}/trash.svg) 0 center/12px no-repeat
              padding-box;" [ngbPopover]=popSaveContent placement="top" #s3="ngbPopover" triggers="manual"
                popoverClass="savedordermini-popover1" (click)="deletePopup(s3)">Delete</span></td>
            <ng-template #popSaveContent>
              <p class="custom-title text-center">Remove this product from your list?</p>
              <button type="button" class="btn-secondary btn-custom" (click)="deletePopup(s3)">
                {{'patientEducation.cancel'|cxTranslate}}
              </button>
              <button class="btn-primary btn-custom ml-2" type="submit" (click)="removeProduct(item,s3)">Delete</button>
            </ng-template>
          </tr>
        </tbody>
      </table>
      <ng-container *ngTemplateOutlet="vaccinesListMobView; context:{$implicit:productList}" ></ng-container>
    </div>
  </section>
  <section>
    <div class="question-style d-flex">
      <div class="mt-1 mr-3">2</div>
      <div>{{constantsValue.secondQuestion}}</div>
    </div>
    <p>{{constantsValue.secondAnswer}}</p>
    <section class="units">
      <div># of boxes</div>
      <section class="unit-area">
        <span aria-hidden="true">

          <img src="/icons/{{baseSiteId}}/less.svg" alt="" (click)="performQuantityComputation('minus','')"
            *ngIf="boxQty.value>1">
          <img src="/icons/{{baseSiteId}}/less-disable.svg" alt="" *ngIf="boxQty.value<=1">
        </span>
        <input type="number" class="prod-quantity text-center" [(ngModel)]="noOfBoxes"
          (keydown)="validateInput($event,'noOfBox')" (keyup)="performQuantityComputation('',$event)"
          id="{{'prodQuantity'}}" #boxQty (focusout)="onFocusOut()" maxlength="2" appNoMouseScroll />
        <span aria-hidden="true">
          <img src="/icons/{{baseSiteId}}/more.svg" (click)="performQuantityComputation('plus','')" alt=""
            *ngIf="boxQty.value<99">
          <img src="/icons/{{baseSiteId}}/more-disable.svg" alt="" *ngIf="boxQty.value>=99">
        </span>
      </section>
    </section>
  </section>
  <section class="email-notification">
    <div class="question-style d-flex">
      <div class="mt-1 mr-3">3</div>
      <div>{{constantsValue.thirdQuestion}}</div>
    </div>
    <p>{{constantsValue.thirdAnswer}}</p>
    <div>
      <span>{{constantsValue.emailReq}}</span>
      <input id="email" name="email" type="text" class="Fields-input" autocomplete="off" [(ngModel)]="emailRequired"
        (keyup)="validateEmail(emailRequired,'required')" placeholder="Email address" (keydown)="validateKey($event)"
        list="autocompleteOff" aria-autocomplete="none" />
      <span *ngIf="!emailRequiredValid" class="errorMessage">Please enter a valid email address.</span>
    </div>
    <div>
      <span>{{constantsValue.emailOpt}}</span>
      <input id="emailOpt1" type="text" placeholder="Additional email address" class="Fields-input" autocomplete="off"
        [(ngModel)]="emailOptional1" (keyup)="validateEmail(emailOptional1,'opt1')" (keydown)="validateKey($event)"
        list="autocompleteOff" aria-autocomplete="none" />
      <span *ngIf="!emailOptional1Valid" class="errorMessage">Please enter a valid email address.</span>
    </div>
    <div>
      <span>{{constantsValue.emailOpt}}</span>
      <input id="emailOpt2" type="text" class="Fields-input" autocomplete="off" placeholder="Additional email address"
        [(ngModel)]="emailOptional2" (keyup)="validateEmail(emailOptional2,'opt2')" (keydown)="validateKey($event)"
        list="autocompleteOff" aria-autocomplete="none" />
      <span *ngIf="!emailOptional2Valid" class="errorMessage">Please enter a valid email address.</span>
    </div>
  </section>
  <section class="term-style">
    <p>Returns are subject to our policy, noted in our <a href="{{pdfUrl}}" target="_blank">Terms and Conditions</a>. The Terms and Conditions are subject to change without prior notification.</p>
    <div class="content-style" [innerHTML]="contentMsg"></div>
    <div class="d-flex"><input type="checkbox" (change)="radioSelected()" [checked]="isRadioSelected" />
      <span class="checkmark"></span>
      <label class="mt-2 ml-1">I have read and acknowledge the above Terms and Conditions and understand<br>the requirements to process my return(s).</label>
    </div>
  </section>
  <hr class="mt-5 mb-5">
  <section>
    <div class="row">
      <div class="plpbutton col-md-4 col-sm-12">

        <button type="button" class="btn-primary mb-2 w-100" (click)="submitRequest(returnSuccessModal)"
          [disabled]="!isValidated">
          Submit
        </button>
      </div>
      <div class="col-md-1 col-sm-3 d-flex flex-row align-items-start justify-content-sm-start justify-content-md-center" *ngIf="isValidated">
        <img src='/icons/{{baseSiteId}}/warning.svg'>
      </div>
      <div class="col-md-5 col-sm-8 alert-msg" *ngIf="isValidated">
        <span>{{constantsValue.alertMsg}}</span>
      </div>
      <div class="col-md-2 col-sm-1">

      </div>
    </div>
  </section>
  <ng-template #returnSuccessModal let-modal>
    <div class="modal-header header-style">
      You've successfully initiated the returns process
    </div>
    <div class="modal-body body-style">
      <div class="row">
        <section class="col-md-7">
          <section class="location mb-3">
            <h6 class="d-flex">
              <div><img src="/icons/{{baseSiteId}}/location.svg"></div>
              <div class="ml-1"><span>{{userInfo?.name}}({{userInfo?.uid}})</span></div>
            </h6>
          </section>
          <section>
            <div class="text-capitalize">{{userInfo?.shippingAddress?.line1}},&nbsp;{{userInfo?.shippingAddress?.line2}}
            </div>
            <div>
              {{userInfo?.shippingAddress?.town}},&nbsp;{{userInfo?.shippingAddress?.country.isocode}}&nbsp;{{userInfo?.shippingAddress?.postalCode}}
            </div>
          </section>
        </section>
        <section class="col-md-5 mt-3">
          <div class="mb-3">
            <a><img src='/icons/{{baseSiteId}}/print.svg' class="svg-images" (click)="OnPrint()"></a><a
              class="print" (click)="OnPrint()">Print</a>
            <a class="ml-3" (click)="downloadFile()"><img src='/icons/{{baseSiteId}}/download-icon.svg'
                class="svg-images-download"></a><a class="print" (click)="downloadFile()">Download</a>
          </div>
          <div>
            <div class="date-style">Date Submitted</div>
            <div>{{todayDate | date:'MM/dd/yyyy'}}</div>
          </div>
        </section>
        <hr class="col-11">
        <section class="col-md-12 return-title">
          <div>Return #</div>
          <div>{{returnKey}}</div>
        </section>
        <!--Next stpes-->
        <section class="next-step">
          <section>
            <p><img class="mr-2" src='/icons/{{baseSiteId}}/warning.svg'>{{constantsValue.nextStep}}</p>
            <div class="d-flex">
              <div class="circle-style">1</div>
              <div class="mb-2">{{constantsValue.nextStepFirst}}</div>
            </div>
            <div class="d-flex">
              <div class="circle-style">2</div>
              <div class="mb-2"><span>{{constantsValue.nextStepSecond}}</span>&nbsp;<span
                  class="font-weight-bold">{{constantsValue.nextStepThird}}</span></div>
            </div>
            <div class="d-flex">
              <div class="circle-style">3</div>
              <div>{{constantsValue.nextStepFourth}}</div>
            </div>
          </section>
          <!--Important notes-->
          <section>
            <div class="notes-style mt-4 mb-2">IMPORTANT NOTES</div>
            <ul class="custom-ul-style">
              <li><span>{{constantsValue.noteFirst}}</span></li>
              <li><span>{{constantsValue.noteSecond}}&nbsp;</span><span>{{constantsValue.noteThird}}</span></li>
              <li><span>{{constantsValue.noteBarcode}}&nbsp;</span><span>{{constantsValue.noteshipping}}</span></li>
              <li><span>{{constantsValue.noteNotLabel}}</span></li>
              <li><span>{{constantsValue.noteNotCover}}&nbsp;</span><span>{{constantsValue.noteLable}}</span></li>
            </ul>
          </section>
          <!--Shipping Address-->
          <section class="text-left mt-4 shipping-address">
            <div class="mb-3">SHIPPING ADDRESS</div>

            <div>Inmar RX Solutions</div>
            <span>3845 Grand Lakes Way,</span><span>Suite 125</span>
            <div class="mb-3">Grand Prairie, TX 75050</div>
          </section>
          <!--Table-->
          <section>
            <div>
              <table class="submit-list-table table" id="submit-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>NDC #</th>
                    <th>Lot #</th>
                    <th>Doses to return</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of productList">
                    <td [innerHTML]="item.name" class="text-left"></td>
                    <td>{{item.ndcNumber}}</td>
                    <td>{{item.lotNumber}}</td>
                    <td>{{item.returnDoses}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="text-left text-policy">Returns are subject to our policy, noted in our <a href="{{pdfUrl}}"
                target="_blank">Terms & conditions</a>
            </div>
          </section>
        </section>
      </div>
    </div>
    <div class="modal-footer footer-style">
      <div class="col-md-12 col-lg-12 col-sm-12">
        <section class="d-flex flex-column justify-content-center btn-style">
          <button type="button" class="btn-primary mb-2" (click)="downloadRALabels()">
            <img [src]="'/icons/'+baseSiteId+'/download-icon.svg'" [ngStyle]="{'height': '20px'}">
            Download RA labels
          </button>
          <button type="button" class="btn-secondary mb-2" (click)="navigateReturnHistory()">
            View Return history
          </button>
        </section>
      </div>
    </div>
  </ng-template>
</section>


<ng-template #vaccinesListMobView let-productList>
  <div class="vaccines-list" *ngFor="let item of productList">
      <ul [ngStyle]="{'padding': '15px 20px'}">
        <li>
          <div class="d-flex flex-row justify-content-between align-items-start">
            <b class="col-6">Product</b>
            <p [innerHTML]="item.name" class="col-6"></p>
          </div>
        </li>
        <li>
          <div class="d-flex flex-row justify-content-between align-items-start">
            <b class="col-6">NDC #</b>
            <p class="col-6">{{item.ndcNumber}}</p>
          </div>
        </li>
        <li>
          <div class="d-flex flex-row justify-content-between align-items-start mb-4">
            <b class="col-6">Lot # (optional)</b>
            <input id="lotNo" type="text" placeholder="Lot #" class="col-6"
              (keyup)="updateLotDoses($event.target.value,'lotno',item.id)"
              (keydown)="validateInput($event,'lotNoDose')" />
          </div>
        </li>
        <li>
          <div class="d-flex flex-row justify-content-between align-items-start mb-4">
            <b class="col-6">Doses to return</b>

            <input type="number" placeholder="0" min="1" max="99999" class="col-6"
              (keyup)="updateLotDoses($event.target.value,'doses',item.id)"
              (keydown)="validateInput($event,'lotNoDose')" />
          </div>
        </li>
        <li class="d-flex justify-content-center">
          <span class="del-icon" style="background: url(/icons/{{baseSiteId}}/trash.svg) 0 center/12px no-repeat
            padding-box;" [ngbPopover]=popSaveContent placement="top" #s3="ngbPopover" triggers="manual"
              popoverClass="savedordermini-popover" (click)="deletePopup(s3)">Delete</span>
          <ng-template #popSaveContent>
            <p class="custom-title text-center">Remove this product from your list?</p>
            <button type="button" class="btn-secondary btn-custom" (click)="deletePopup(s3)">
              {{'patientEducation.cancel'|cxTranslate}}
            </button>
            <button class="btn-primary btn-custom ml-2" type="submit" (click)="removeProduct(item,s3)">Delete</button>
          </ng-template>
        </li>
      </ul>
  </div>
</ng-template>
